export default "/images/dark-mode.png?8a931eda0561fbb8795250a8c4ee2902";